import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import element from "./element/index";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Vant from "vant";
import "vant/lib/index.css";
Vue.use(element);
Vue.use(ElementUI);
Vue.use(Vant);

import $ from "jquery";

import "@vant/touch-emulator";

Vue.prototype.$ = $;

Vue.config.productionTip = false;
import * as echarts from "echarts";

Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
